import { SVGUniqueID } from './svg-unique-id';
import type { IconProps } from './types';
const Icon = (props: IconProps) => (
  <svg
    width={props.size || 24}
    height={props.size || 24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.11 2.26L20.78 7.51C20.8478 7.55475 20.9034 7.61565 20.9418 7.68722C20.9802 7.75879 21.0002 7.83878 21 7.92L21 8L21 8.08C21 8.08095 21 8.0819 21 8.08284V15.737C21 16.2309 20.7568 16.6932 20.3498 16.973L13.1331 21.9346C12.4506 22.4038 11.5494 22.4038 10.8669 21.9346L3.65021 16.973C3.24317 16.6932 3 16.2309 3 15.737V8.0811V8L3 7.92C2.99982 7.83878 3.01983 7.75879 3.05823 7.68722C3.09663 7.61565 3.15222 7.55475 3.22 7.51L10.89 2.26C11.1375 2.0908 11.4302 2.00019 11.73 2H12.27C12.5698 2.00019 12.8625 2.0908 13.11 2.26ZM5 9.70838V15.474L11 19.599V13.8084C10.9625 13.7873 10.9258 13.7644 10.89 13.74L5 9.70838ZM13 13.8084V19.599L19 15.474V9.70838L13.11 13.74C13.0742 13.7644 13.0375 13.7873 13 13.8084ZM11.89 12H12.11L18 8L12.07 4H11.85L6 8L11.89 12Z"
      fill={props.color || 'currentColor'}
    />
  </svg>
);
const SvgObject = (props: IconProps) => (
  <SVGUniqueID>{Icon(props)}</SVGUniqueID>
);
export default SvgObject;
